import store from '@/store'
import { getData } from '@core/utils/http/general'
import { ref, watch } from '@vue/composition-api'
import { paginateArray, removeAccents } from '@core/utils/utils'

export const useCompras = () => {
  const formPagos = [
    { id: 1, name: 'Pago Cheque Bancario' },
    { id: 2, name: 'Transferencia Electrónica' },
    { id: 3, name: 'Pago Efectivo' },
  ]

  return {
    formPagos,
  }
}

// Make http request to get info by order [id]
export const getEspecialidades = () => new Promise((resolve, reject) => {
  const paramsRequest = {
    action: 2,
    token: store.state.cuenta.session.token,
  }
  getData(paramsRequest, 'wsalumno')
    .then(response => {
      if (response.status === 200 && response.data.status === 200) {
        resolve({ result: response.data.data, msn: response.data.message })
      } else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})
export const getcuatrimestres = iden => new Promise((resolve, reject) => {
  const paramsRequest = {
    action: 3,
    id_plan: iden,
    token: store.state.cuenta.session.token,
  }
  getData(paramsRequest, 'wsalumno')
    .then(response => {
      if (response.status === 200 && response.data.status === 200) {
        resolve(response.data.data)
      } else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})
export const getCurso = (kdex, mat) => new Promise((resolve, reject) => {
  const paramsRequest = {
    action: 7,
    kardex: kdex,
    materia: mat,
    token: store.state.cuenta.session.token,
  }
  getData(paramsRequest, 'wsalumno')
    .then(response => {
      if (response.status === 200 && response.data.status === 200) {
        resolve({ calificaciones: response.data.calificaciones })
      } else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})
export const detailMateria = mat => new Promise((resolve, reject) => {
  const paramsRequest = {
    action: 2,
    materia: mat,
    token: store.state.cuenta.session.token,
  }
  getData(paramsRequest, 'wsmaterias')
    .then(response => {
      if (response.status === 200 && response.data.status === 200) {
        resolve({ info: response.data.materia, modulos: response.data.modulos, seriaciones: response.data.seriaciones })
      } else reject(response.data.message)
    })
    .catch(err => { reject(err) })
})
//* Method to fill classmate list and filter data
export const configListClassmate = () => {
  const perPage = ref(5) //* How many items show per page
  const totalItems = ref(0) //* Total items
  const currentPage = ref(1) //* Current page
  const perPageOptions = [5, 10, 25, 50, 100] //* Page options, how many items will show
  const searchQuery = ref('') //* Search string
  const isBusy = ref(false) //* Data is loading [flag]
  const temporalClassmates = ref([])
  const classmates = ref([])

  //* Filter classmate by name and mail
  const filterClassmates = () => new Promise(resolve => {
    const queryLowered = removeAccents(searchQuery.value.toLowerCase()) //* Transform search string to lowercase and remove accents
    resolve(
      classmates.value.filter(
        item => (
          removeAccents(item.nombre).toLowerCase().includes(queryLowered) //* Filter data by nombre
          || removeAccents(item.email).toLowerCase().includes(queryLowered) //* Filter data by nombre
        ),
      ),
    )
  })

  //* Make http request to get classmates
  const fetchData = curso => new Promise((resolve, reject) => {
    const paramsRequest = {
      action: 8,
      curso,
      token: store.state.cuenta.session.token,
    }

    getData(paramsRequest, 'wsalumno')
      .then(response => {
        if (response.status === 200 && response.data.status === 200) {
          classmates.value = response.data.data
          totalItems.value = classmates.value.length
          temporalClassmates.value = paginateArray(classmates.value, perPage.value, currentPage.value)
          resolve()
        } else reject(response.data.message)
      })
      .catch(err => { reject(err) })
  })

  watch([currentPage, perPage, searchQuery], () => {
    if (classmates.value.length) {
      isBusy.value = true
      filterClassmates().then(response => {
        totalItems.value = response.length
        temporalClassmates.value = paginateArray(response, perPage.value, currentPage.value)
        isBusy.value = false
      })
    }
  })

  return {
    // Data
    classmates,
    temporalClassmates,

    // Filters
    perPage,
    totalItems,
    currentPage,
    perPageOptions,
    searchQuery,

    // Methods
    fetchData,

    // Loader
    isBusy,
  }
}
export const configTableRecursa = () => {
  //* This will be our table columns => { key: 'name of the object propiety', label: 'how to show in table' }
  const tableColumns = [
    {
      key: 'folio', label: 'folio', sortable: true, isRowHeader: true,
    },
    {
      key: 'matricula', label: 'matricula', sortable: true, isRowHeader: true,
    },
    {
      key: 'opciones', label: 'Acciones',
    },
    {
      key: 'periodo', sortable: true,
    },
    {
      key: 'fecha_solicitud', label: 'fecha de solicitud', sortable: true,
    },
    {
      key: 'motivo', sortable: true,
    },
    {
      key: 'resolucion', sortable: true,
    },
    {
      key: 'fecha_resol', label: 'fecha de resolución', sortable: true,
    },
  ]
  //* Params to fill table data & filters
  const configRequest = ref({
    wsParams: { action: 20, token: store.state.cuenta.session.token }, //* Request params
    wsType: 'wsalumno', //* WebService name
    filterGetter: 'cuenta/filterDatosRecursamiento',
  })

  return { tableColumns, configRequest }
}
